import { Popup, PopupDirection } from 'lego-on-react';
import React, { useRef, useState } from 'react';

import block from 'propmods';

import './PicturePopup.scss';

const b = block('PicturePopup');

interface Props {
    src: string;
    directions?: PopupDirection[];
}

export const PicturePopup: React.FC<Props> = ({ children, src }) => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef<HTMLSpanElement>(null);

    const toggle = () => setIsVisible(!isVisible);

    return (
        <>
            <span ref={ref} onClick={toggle}>
                {children}
            </span>
            <Popup
                hasTail
                tailSize={12}
                tailOffset={10}
                secondaryOffset={-10}
                autoclosable
                theme="normal"
                target="anchor"
                visible={isVisible}
                anchor={() => ref.current}
                onOutsideClick={() => setIsVisible(false)}
            >
                <div {...b()}>
                    <img src={src} {...b('picture')} />
                </div>
            </Popup>
        </>
    );
};
